import { Pipe, PipeTransform } from '@angular/core';
import { getOnlyNumberFromString } from '@utils/number.util';

@Pipe({
  name: 'deducible',
})
export class DeduciblePipe implements PipeTransform {
  transform(value: string): number {
    return getOnlyNumberFromString(value);
  }
}
